import { render } from "./StationDetailSkeleton.vue?vue&type=template&id=46d38968&scoped=true"
const script = {}

import "./StationDetailSkeleton.vue?vue&type=style&index=0&id=46d38968&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d38968"]])

export default __exports__